import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';

export default class McmZillowJob extends McmJob<typeof McmZillowConfig> {
  get performable() {
    return McmZillowConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmZillowConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];

    if (this.orderHasPerformable('photo') && this.buyer('crossroads')) {
      return lines;
    }

    lines.push({
      id: 'zillow',
      description: 'Zillow 3D',
      amount: new Big('99.95'),
    });

    return lines;
  }

  onsite(): number {
    return 30;
  }

  get hidden(): boolean {
    return Boolean(this.buyer('crossroads') || this.buyer('sothebys'));
  }
}
